import CountsCard from "@components/BasicComponents/Cards/CountsCard/CountsCard"
import Separator from "@components/CustomTypography/Separator/Separator"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CompanyCountsSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	flex?: string
	asRoadMap?: boolean
	withoutAsset?: boolean
}

const CompanyCountsSection = (props: Props) => {
	return (
		<section>
			{/* Features Cards list */}
			<Separator className={styles.container} withoutMeasure>
				{props.data.mainContent?.map(
					(element: AdvancedSideAssetMainContent, index: number) => {
						return (
							<CountsCard
								key={index}
								className={styles.countBox}
								data={element}
							/>
						)
					},
				)}
			</Separator>
		</section>
	)
}

export default CompanyCountsSection
